import { slugify } from 'react-shared/utils/string';

export function pushEvent(action, label, category = 'geral') {
  window.dataLayer.push({
    event: 'event',
    eventCategory: `${window.blz.organization}:${category}`,
    eventAction: action,
    eventLabel: label
  });
}

export function handleLazyShelfDataLayerEvents(elements) {
  BLZProductImpression(createProducsImpressiontData(elements));
  createProductImpressionClick(elements);
}

const buttonActions = {
  'Bought-Together': {
    trigger: (_data, ele) => {
      const eleParent = ele.currentTarget.closest('.bought-together');
      const secondaryProductEle =
        eleParent?.querySelector('.bought-together-product-text a:last-of-type') || {};
      pushEvent(
        'clique:botao',
        `comprar-os-2-itens:${slugify(secondaryProductEle?.innerText || '')}`,
        'pdp'
      );
    }
  }
};

const linkActions = {
  'Show-All-SKU': {
    trigger: () => {
      pushEvent('clique:link', 'ver-todas-+', 'pdp');
    }
  },
  'Rate-Product': {
    trigger: () => {
      pushEvent('clique:botao', 'avalie-esse-produto', 'pdp');
    }
  }
};

const interactionActions = {
  'header-click': {
    execute: (data) => {
      pushEvent('clique:header', slugify(data.label));
    }
  },
  'accessibility-click': {
    execute: (data) => {
      pushEvent('clique:menu-acessibilidade', slugify(data.label));
    }
  },
  'brand-click': {
    execute: (data) => {
      pushEvent('clique:menu-marcas', slugify(data.label));
    }
  },
  'footer-click': {
    execute: (data, ele) => {
      const itemCol = ele.target.closest('.footer-col');
      const itemTitle = itemCol.querySelector('.footer-title');

      const footerColGroup = (!!itemCol && itemTitle?.innerText) || '';

      pushEvent('clique:footer:link', `${slugify(data.label)}:${slugify(footerColGroup)}`);
    }
  },
  'menu-click': {
    execute: (_data, ele) => {
      const parentMenu = ele.currentTarget.closest('.menu-item');

      const parentMenuTitle =
        (!!parentMenu && parentMenu.querySelector('.menu-item-link').getAttribute('title')) || '';
      pushEvent(
        'clique:header-menu',
        `${slugify(parentMenuTitle)}:${slugify(ele.currentTarget.getAttribute('title') || '')}`
      );
    }
  },
  'filter-click': {
    execute: (data) => {
      const filter = slugify(data.label);
      const splitedValue = data.values.split(';');
      if (data.values && splitedValue.length > 1) {
        const selectedFilter = slugify(splitedValue[1] || '');
        pushEvent('interacao:filtros', `${filter}:${selectedFilter}`);
      }
    }
  },
  'link-click': {
    execute: (data, ele) => {
      linkActions[data?.label || '']?.trigger(data, ele);
    }
  },
  'button-click': {
    execute: (data, ele) => {
      buttonActions[data?.label || '']?.trigger(data, ele);
    }
  }
};

function baseEcommercePush(data, event, category) {
  window.dataLayer.push({
    event,
    eventCategory: window.blz.organization + ':enhanced-ecommerce',
    eventAction: event,
    noInteraction: '1',
    ecommerce: {
      [category]: data
    }
  });
}

function BLZProductImpression(products) {
  products?.length && baseEcommercePush(products, 'productImpression', 'impressions');
}

function BLZPromotionImpression(promotions) {
  if (promotions) {
    baseEcommercePush(promotions, 'promotionImpression', 'promoView');
  }
}

function BLZPromotionClick(element) {
  const data = JSON.parse(element.getAttribute('data-banner') || '{}');
  const promotions = {
    promotions: [
      {
        id: (data.zone || '') + ':' + slugify(data.bannerTitle || ''),
        name: slugify(data.bannerTitle || ''),
        position: data.position || 0
      }
    ]
  };
  baseEcommercePush(promotions, 'promotionClick', 'promoClick');
}

function proxyInterceptor(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const banners = entry.target.querySelectorAll('[data-banner]') || [];
      const bannersData = [...banners].reduce((acc, cur) => {
        const data = JSON.parse(cur?.dataset?.banner || {});
        return [
          ...acc,
          {
            id: (data?.zone || '') + ':' + slugify(data?.bannerTitle || ''),
            name: slugify(data?.bannerTitle || ''),
            position: data?.position || 0
          }
        ];
      }, []);

      BLZPromotionImpression({ promotions: bannersData });
      observer.unobserve(entry.target);
    }
  });
}

function proxyInterceptorProducts(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const elements = entry.target.querySelectorAll('[data-event]') || [];
      BLZProductImpression(createProducsImpressiontData(elements));
      createProductImpressionClick(elements);
      observer.unobserve(entry.target);
    }
  });
}

function createProductImpressionClick(elements) {
  [...(elements || [])]
    .filter((ele) => !!JSON.parse(ele?.dataset?.event || {})?.sku)
    .forEach((ele) => {
      ele?.addEventListener('click', (event) => {
        const dataEvent = JSON.parse(event?.currentTarget?.dataset?.event || {});
        const data = {
          actionField: { list: slugify(dataEvent?.listTitle || '') },
          products: [
            {
              id: dataEvent?.sku || '',
              name: slugify(dataEvent?.productName || ''),
              position: dataEvent?.position || 0,
              price: dataEvent?.price,
              brand: dataEvent?.brand
            }
          ]
        };
        baseEcommercePush(data, 'productClick', 'click');
      });
    });
}

function createProducsImpressiontData(elements) {
  return [...(elements || [])]
    .filter((ele) => !!JSON.parse(ele?.dataset?.event || {})?.sku)
    .reduce((acc, cur) => {
      const data = JSON.parse(cur?.dataset?.event || {});
      return [
        ...acc,
        {
          id: data?.sku || '',
          name: slugify(data?.productName || ''),
          position: data?.position || 0,
          price: data?.price,
          brand: data?.brand,
          list: slugify(data?.listTitle || '')
        }
      ];
    }, []);
}

function initInterSectionObserver() {
  const leaderboards = document.querySelectorAll('.banner-leaderboard');
  const billboards = document.querySelectorAll('.billboard');
  const swiperCards = document.querySelectorAll('.swiper-cards');
  const headerBanners = document.querySelectorAll('.slot-header-banner');

  const observer = new IntersectionObserver(proxyInterceptor);

  [...leaderboards, ...billboards, ...swiperCards, ...headerBanners].forEach((ele) =>
    observer.observe(ele)
  );
}

function initIntersectionObserverProducts() {
  const showcase = document.querySelectorAll('.showcase');
  const showcaseWithSix = document.querySelectorAll('.showcase-with-6');
  const showcaseGondula = document.querySelectorAll('.showcase-gondola');

  const observer = new IntersectionObserver(proxyInterceptorProducts);

  [...showcase, ...showcaseWithSix, ...showcaseGondula].forEach((ele) => observer.observe(ele));
}

function initWithPolyfill() {
  return blz.utils.loadjs(
    blz.globals.cdnPath + blz.globals.rawPath + '/assets/js/intersection-observer.min.js',
    function () {
      init();
    }
  );
}

function initBannerClickListner() {
  const banners = document.querySelectorAll('[data-banner]');
  const socialLinks = document.querySelectorAll('.btn-social-banner');

  banners.forEach((element) => {
    element.addEventListener('click', () => {
      BLZPromotionClick(element);
    });
  });

  socialLinks.forEach((element) => {
    element.addEventListener('click', () => {
      const parentSlider = element.closest('.swiper-slide');
      if (parentSlider) {
        const banner = parentSlider.querySelector('[data-banner]');
        BLZPromotionClick(banner);
      }
    });
  });
}

function initInteractionListener() {
  const interactions = document.querySelectorAll('[data-interaction]');
  interactions.forEach((element) => {
    element.addEventListener('click', (ele) => {
      const jsonObj = ele.currentTarget.getAttribute('data-interaction') || '{}';

      const data = JSON.parse(jsonObj);
      const regx = new RegExp(Object.keys(interactionActions).join('|'));

      if (data.action && regx.test(String(data.action).toLowerCase())) {
        interactionActions[data.action.toLowerCase() || 'default'].execute(data, ele);
      }
    });
  });
}

// PAGE HOME
function serviceSectionListener() {
  const storeServices = document.querySelectorAll('.service-section .service');

  storeServices.length &&
    storeServices.forEach((ele) => {
      ele.addEventListener('click', (event) => {
        const currentService = event.currentTarget;
        const description = currentService.querySelector('.service-description')?.innerText || '';
        pushEvent('clique:botao:componente', slugify(description), 'home');
      });
    });
}

function init() {
  initInterSectionObserver();
  initIntersectionObserverProducts();
  initBannerClickListner();
  initInteractionListener();
  serviceSectionListener();
}

!window.IntersectionObserver ? initWithPolyfill() : init();
